// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Navigation-pageControl-___pageControl__container___3InJA","control-list":"src-components-Navigation-pageControl-___pageControl__control-list___2HYoT","page-control":"src-components-Navigation-pageControl-___pageControl__page-control___3p9Gu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/pageControl/pageControl.css
// module id = 798
// module chunks = 0